<template>
	<div id="udbudpage" class="clearfix">
    <template>
      <div class="clearfix marketplaceItems col-11" >
            <div class="col-12 px0 mx3">
                    <div class="col-12 px0">
                      <div class="flex justify-start mt3">
                        <p class="h4 semi-bold line-height-2 my2 darkblue">
                          Udbud
                        </p>
                      </div>  
                      <p class="h5 regular darkblue line-height-golden my3">
                        Udbud.dk giver et overblik over danske myndigheders indkøb. Udbud.dk viser både nationale udbud, EU-udbud og myndighedernes indkøbsplaner. Siden opdateres med nye udbud. EU-udbud vies på udbud.dk med tilladelse fra EU's Publikationskontor.
                      </p>
                        <div class="col-12 px0">
                          <div class="flex justify-start items-center py1 border muted-border mediumgrey shadow mb2">
                            <div class="flex-none px2">
                              <svg class="relative" style="top:3px;" width="18" height="24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path class="st0" d="M8.8 15.4c3.6 0 6.6-3 6.6-6.6s-3-6.6-6.6-6.6 -6.6 3-6.6 6.6S5.2 15.4 8.8 15.4zM15.7 14.2l4 4c0.4 0.4 0.4 1.1 0 1.5s-1.1 0.4-1.5 0l0 0 -4-4c-3.8 3-9.3 2.3-12.3-1.5S-0.5 4.8 3.4 1.9s9.3-2.3 12.3 1.5C18.2 6.6 18.2 11 15.7 14.2L15.7 14.2z"/></svg>
                            </div>
                            <input class="searchBox gibson h4 darkblue regular mb0 p2 col-10 pl0" type="search" name="search" v-model="search" placeholder="Søg efter" style="background:transparent;border:0px!important;">
                            <!-- <input type="submit" value="Search" class="searchButton"> -->
                          </div>
                        </div>
                    </div>
              <div class="col-12 px0 flex justify-start items-center mt3 mb2">
                        <div class="col-6 pr1 pl0">
                          <button v-b-toggle.webCustomers class="col-12 p2 px2 gibson dark-button not-rounded flex justify-center items-center">
                            <span class="h5 mb0">Sortér</span>
                            <span class="relative ml2" style="top:4px;">
                              <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -8 24 24" width="16" height="16" preserveAspectRatio="xMinYMin" class="jam jam-chevron-down"><path d='M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z' /></svg>
                            </span>
                          </button>
                        </div>
                        <div class="col-6 px0">
                          <button v-b-toggle.m2m class="col-12 p2 px2 gibson dark-button not-rounded flex justify-center items-center">
                            <span class="h5 mb0 mr2">Filter</span>
                            <span class="when-closed">
                              <span class="relative" style="top:3px;">
                                <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -8 24 24" width="16" height="16" preserveAspectRatio="xMinYMin" class="jam jam-chevron-down"><path d='M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z' /></svg>
                              </span>
                            </span>
                            <span class="flex-none when-opened">
                              <span class="relative" style="top:3px;">
                                <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -7.5 24 24" width="16" height="16" preserveAspectRatio="xMinYMin" class="jam jam-chevron-up"><path d='M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z' /></svg>
                              </span>
                            </span>
                          </button>
                        </div>
              </div>
            </div>
            <b-collapse id="m2m" class="flex col-12 ml3">
                      <div class="py1"></div>
                    <div class="col-12 px0 flex flex-wrap justify-start items-center my2">
                          <div class="flex flex-column col-12 mx-auto" >
                          <p>Category</p>
                          <div><b-form-checkbox :id="item+index" v-model="statusfilter" v-for="(item,index) in categoryfilter" :key="index" :name="item+index" :value="item" class="col-2" >
                          <span class=" h6 regular" style="top:-3px;">{{item}}</span>
                          </b-form-checkbox></div>
                          </div>
                    </div>
                    <div class="col-12 px0 flex flex-wrap justify-start items-center my2">
                          <div class="flex flex-column col-12 mx-auto" >
                          <p>Byer</p>
                          <div><b-form-checkbox :id="item+index" v-model="statusfilter" v-for="(item,index) in citiesfilter" :key="index" :name="item+index" :value="item" class="col-2" >
                            <span class=" h6 regular" style="top:-3px;">{{item}}</span>
                          </b-form-checkbox></div>
                          </div>
                    </div>
                      <div class="my1 col-12 mb3 mx-auto ">
                        <button class="col-3 action-button p2 gibson not-rounded " @click="toggleFilter(statusfilter)">
                          <span class="h4 mb0">Filter nu</span>
                          <span class="ml1"><i class="el-icon-right"></i></span>
                        </button>
                      </div>
                    <div class="py1"></div>
            </b-collapse>
            <b-collapse id="webCustomers" class="col-6">
                <div class="clearfix m3">
                  <div class="pb3"></div>
                    <b-form-group :value.sync="statusDate" v-slot="{ ariaDescribedby }">
                      <b-form-radio-group >
                  <b-form-radio id="Sortbyalphacity" v-model="statusDate" :aria-describedby="ariaDescribedby" name="Sortbyalphacity" value="1" >
                    <span class="ml1 h6 regular relative" style="top:-3px;">Sorter efter by</span>
                  </b-form-radio>
                  <div class="clearfix"></div>
                  <b-form-radio id="Sortbydatecreated" v-model="statusDate" :aria-describedby="ariaDescribedby" name="Sortbydatecreated" value="2" >
                    <span class="ml1 h6 regular relative" style="top:-3px;">Sorter efter oprettet dato</span>
                  </b-form-radio>
                  <div class="clearfix"></div>
                  <b-form-radio id="Sortbydateedited" v-model="statusDate" :aria-describedby="ariaDescribedby" name="Sortbydateedited" value="3" >
                    <span class="ml1 h6 regular relative" style="top:-3px;">Sorter efter redigeringsdato</span>
                  </b-form-radio>
                  <div class="clearfix"></div>
                  <b-form-radio id="Sortbydatedeadline" v-model="statusDate" :aria-describedby="ariaDescribedby" name="Sortbydatedeadline" value="4" >
                    <span class="ml1 h6 regular relative" style="top:-3px;">Sorter efter dato deadline</span>
                  </b-form-radio>
                      </b-form-radio-group>
                        </b-form-group>
                  <div class="pb5"></div>
                  <div class="clearfix">
                    <button class="col-6 action-button p2 gibson not-rounded" @click="toggleSort(statusDate)" >
                      <span class="h4 mb0">Sorter nu</span>
                      <span class="ml1"><i class="el-icon-right"></i></span>
                    </button>
                  </div>
                </div>
            </b-collapse>
            <div class="py2"></div>
            <!-- <div class="ml2 flex flex-wrap col-12 justify-start"> -->
              <div class="clearfix flex flex-wrap justify-start" style="padding: 2em;">
              <!-- desktop view udbud list -->
              <div class="muted-border border shadow px0 pb3 mr2 mb2" v-for="(item,index) in itemMester"  v-bind:key="index"  @click="showGotoUrl(item)" style="overflow: hidden; cursor: pointer !important; width: 275px;">
                <div class="col-12 px0 relative" style="height:inherit;">
                    <!-- <img :src="static/img/udbud_og.webp" alt="Udbud Logo" class="fit block absolute bottom-0 left-0 right-0" style="top: 50%;left:5%; height: 25px; width: 95%;">  <img :src="static/img/udbud_og.webp" alt="Udbud Logo" class="fit block absolute bottom-0 left-0 right-0" style="top: 50%;left:5%; height: 25px; width: 95%;"> -->
                    <img v-if="item.PICTURE_URL" :src="item.PICTURE_URL" alt="Udbud Logo" class="fit block" style="height: 180px; object-fit: cover; width: 100%;">
                    <img v-else src="https://www.haandvaerker.dk/uploads/00.webp" alt="Udbud Logo" class="fit block" style="height: 180px; object-fit: none; width: 100%;"></img>
                    <div class="absolute top-0 right-0 left-0">
                      <span class="mintgreen-background p1 line-height-1 block px2">
                        <span class="h6 m0 p0 white semi-bold block">
                          {{ item.UF_CITY }}
                        </span>
                        <span class="h6 m0 p0 white semi-bold block ">
                          <!-- {{ item.UF_CITY }} -->
                        </span>
                      </span>
                  </div>
                </div>
                <div class="col col-8 px2 pr0">
                  <div class="flex flex-column">
                    <p class="h5 semi-bold darkblue gibson line-height-2 pt2 flex justify-between items-center">
                      <span>{{ item.UF_TITLE }}</span>
                      <span class="red" v-if="item.reserved === 1">Reserved</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
      </div>
    </template>
    <div class="py4"></div>
    <b-modal lazy  v-model="itemShow" ref="itemModal" style="transform: none!important;">
      <div class="col-12 flex justify-end">
        <button @click="hideModal()" class="z3 white-button border-none not-rounded gibson pointer">
          <span>
            <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-6 -6 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-close"><path d='M7.314 5.9l3.535-3.536A1 1 0 1 0 9.435.95L5.899 4.485 2.364.95A1 1 0 1 0 .95 2.364l3.535 3.535L.95 9.435a1 1 0 1 0 1.414 1.414l3.535-3.535 3.536 3.535a1 1 0 1 0 1.414-1.414L7.314 5.899z' /></svg>
          </span>
        </button>
      </div>
      <slot name="modal-header" class="relative p0" style="height:300px;">
        <div class="relative">
          <div style="height:180px;"><img src="static/img/udbud_og_big.webp" alt="" class="fit block mx-auto" style="height:90px;width:90%;"></div>
          <div class="absolute bottom-0 right-0 left-0 mintgreen-background p2 line-height-1 z2 flex justify-between items-center">
            <span class="h6 m0 p0 white semi-bold">{{ itemSelect.POSTAL_CODE }}  {{ itemSelect.CITY }}</span>
          </div>
        </div>
      </slot>
      <div class="modal-body-marketplace">
        <div class="clearfix ">
          <div class="flex flex-column mt3 mb2">
            <p class="h5 darkblue gibson semi-bold mb1 p0 line-height-2">
              {{itemSelect.producttitle}}
            </p>
            <div class="h6 darkblue gibson regular m0 p0 line-height-1">
              <span class="flex justify-start items-center mb3 col-12">
                <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-2 -3 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-calendar-alt"><path d='M9 2V1a1 1 0 1 1 2 0v1h3V1a1 1 0 0 1 2 0v1h1a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h1V1a1 1 0 1 1 2 0v1h3zm0 2H6v1a1 1 0 1 1-2 0V4H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-1v1a1 1 0 0 1-2 0V4h-3v1a1 1 0 0 1-2 0V4zM3 8h2v2H3V8zm0 4h2v2H3v-2zm12 0h2v2h-2v-2zm0-4h2v2h-2V8zM7 8h2v2H7V8zm4 0h2v2h-2V8zm0 4h2v2h-2v-2zm-4 0h2v2H7v-2z'/></svg>
                <p class="m0 p0 h6 darkblue sime-bold">Ring og aftal møde-dato</p>
              </span>
              <!-- <div class="flex" ><p class="col-4">Client :</p><p>Municipality</p></div> -->
              <div class="flex" ><p class="col-3">Publiceret:</p><p>{{ moment(itemSelect.appointment_date).locale('da').format('LL') }}</p></div>
              <div class="flex" ><p class="col-3">Deadline:</p><p v-if="itemSelect.TENDER_DEADLINE !== null ">{{ moment(itemSelect.TENDER_DEADLINE).locale('da').format('LL') }} <br />See time under tender details</p></div>
              <div class="flex" ><p class="col-3">Sted:</p><p>{{ itemSelect.POSTAL_CODE }}  {{ itemSelect.CITY }}</p></div>
              <div class="flex" ><p class="col-3">Titel:</p><p>{{ itemSelect.PROCUREMENT_TITLE }}</p></div>
              <div class="flex" ><p class="col-3">Beskrivelse:</p><p class="line-height-2" v-html="itemSelect.PROCUREMENT_DESCRIPTION " style="width: 65%;"></p></div>
            </div>
          </div>
        </div>
  <!-- <div>
          <div class="clearfix my3">
            <div class="flex col-12">
              <div class="col-12 mx-auto pr1 pl0">
                <button v-b-toggle.comments class="col-12 outlined-dark-button p2 gibson h6 not-rounded flex justify-center items-center">
                  <span>Se beskrivelse</span>
                  <span class="flex-none when-closed">
                    <span class="relative" style="top:3px;">
                      <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -8 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-down"><path d='M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z' /></svg>
                    </span>
                  </span>
                  <span class="flex-none when-opened">
                    <span class="relative" style="top:3px;">
                      <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -7.5 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-up"><path d='M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z' /></svg>
                    </span>
                  </span>
                </button>
              </div>
            </div>
          </div>-->
          <!--  <div class="clearfix">
          <b-collapse id="details" class="">
              <div class="clearfix flex flex-column regular gibson mb2 px2">
                <div class="flex" ><p>Client :</p><p>Municipality</p></div>
                <div class="flex" ><p>Announced:</p><p>{{ moment(itemSelect.appointment_date).locale('da').format('LL') }}</p></div>
                <div class="flex" ><p>Deadline:</p><p>{{ moment(itemSelect.TENDER_DEADLINE).locale('da').format('LL') }} See time under tender details</p></div>
                <div class="flex" ><p>Place of delivery:</p><p>{{ itemSelect.POSTAL_CODE }}  {{ itemSelect.CITY }}</p></div>
              </div>
            </b-collapse>
            <b-collapse visible id="comments">
              <div class="clearfix mb3 px2">
                <div>
                  <p class="h6 darkblue regular gibson line-height-golden">
                    The tender relates to the conclusion of contracts for the performance of cleaning tasks in Kalundborg Municipality ("Contracting Authority") at schools, SFOs, children's institutions, administrative buildings, as well as special offers for the physically and mentally handicapped, halls and public toilets.
                    <br /><br />
                    Pursuant to section 49 of the Public Procurement Act, the contracting authority has assessed the division of the service into additional subcontracts. Based on both practical and financial reasons, including the consideration of obtaining economies of scale, the Contracting Authority has decided on the division into 3 subcontracts. The tender is divided into the following 3 subcontracts (districts):
                    <br /><br />
                    Subcontract 1: District South, cf. Appendix A (approx. 44,249 m2).
                    <br /><br />
                    Subcontract 2: District North, cf. Appendix B (approx. 77,926 m2).
                    <br /><br />
                    Subcontract 3: District East, cf. Appendix C (approx. 50,529 m2). Pre-qualification for one or more subcontracts can be applied for.
                  </p>
                </div>
              </div>
            </b-collapse>
          </div> 
        </div>-->
      </div>  
      <!-- modalFooter -->
      <div slot="modal-footer">
        <div class="clearfix flex justify-between items-center border-top" style="border-color:rgba(178,190,195, 0.5);">
          <a type="button" :href="itemSelect.FORM_URL_ID" target="_blank" :disabled="isLoadingReserve" class=" col-12 green-background p3 white sime-bold gibson mx-auto m0 no-underline ">
            <span class="mx2">Se mere på udbud.dk</span>
            <span><i class="el-icon-right"></i></span>
          </a>
        </div>
      </div>
    </b-modal>
    <loading :show="show" :label="label" :overlay="overlay"></loading>
    <!-- </transition-group> -->
    <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
    <noneligibleFeaturepop ref="noneligibleFeaturepop"></noneligibleFeaturepop>
    <updatebitrixpackagepermission   ref="updatebitrixpackagepermission"></updatebitrixpackagepermission>
	</div>
</template>
<script>
import archivemodal from './modals/ArchiveModal'
import loading from 'vue-full-loading'
import Simplert from 'vue2-simplert'
import { Datetime } from 'vue-datetime'
import noneligibleFeaturepop from './noneligibleFeaturepop'
import updatebitrixpackagepermission from '../../components/updatebitrixpackagepermission'
export default {
  name: 'ted udbud',
  components: {
    loading,
    Simplert,
    archivemodal,
    datetime: Datetime,
    noneligibleFeaturepop,
    updatebitrixpackagepermission
  },
  watch: {
    'search': function (newVal, oldVal) {
      setTimeout(() => {
        this.updateSearch()
      }, 200)
      this.SearchItem = []
    }
  },
  created () {
    if (screen.width <= 640) {
      this.showMobile = true
    } else {
      this.showMobile = false
      this.showXXL = true
    }
    this.reloadudbudtest()
    if (localStorage.getItem('basic') === '1') {
      this.basic = true
    }
    this.partnerName = localStorage.getItem('name')
  },
  data () {
    return {
      items: [],
      itemMester: [],
      itemreserved: [],
      show: false,
      search: '',
      isLoadingReserve: false,
      label: 'Loading...',
      overlay: 1,
      basic: false,
      SearchItem: [],
      statusfilter: [],
      statusDate: [],
      citiesfilter: [],
      categoryfilter: [],
      partnerName: '',
      usershorturl: '',
      isLoadingMail: false,
      step: 1,
      partnerinvoice: 0,
      itemSelect: [],
      itemShow: false,
      itemShowMester: false,
      loading: true
    }
  },
  mounted () {
    // this.getdataigibility()
  },
  methods: {
    getdataigibility () {
      setTimeout(() => {
        this.eligible = localStorage.getItem('PartnerLoginUdbudJobs')
        console.log('eligible', this.eligible)
        if (this.eligible === 'false') {
          this.$refs.noneligibleFeaturepop.showmodel(this.eligible, '/newsfeed', 'PartnerLoginUdbudJobs')
        }
      }, 2000)
    },
    checkimage (key) {
      var img = document.querySelector('img[data-key="' + key + '"]')
      img.src = 'static/img/0.jpg'
    },
    showItemDetails (item) {
      if (item.reserved === 1) {
        return
      }
      if (this.basic && item.mester !== '1') {
        return
      }
      this.itemShow = !this.itemShow
      this.itemSelect = item
      this.usershorturl = this.itemSelect.shorturl
      this.loading = false
      this.step = 1
    },
    showItemDetailsMester (item) {
      this.itemShow = !this.itemShow
      this.itemSelect = item
      this.loading = false
      this.step = 1
    },
    showGotoUrl (item) {
      window.open(item.UF_DESCRIPTION_URL, '_blank')
    },
    reloadudbud () {
      // try {
      //   // var headers = {
      //   //   header('Access-Control-Allow-Origin': '*');
      //   //   header("Access-Control-Allow-Methods: PUT, GET, POST");
      //   //   header("Access-Control-Allow-Headers: Origin, X-Requested-With, Content-Type, Accept");
      //   // },
      //   const headers = {
      //     'Access-Control-Allow-Origin': '*',
      //     'Access-Control-Allow-Methods': 'PUT, GET, POST',
      //     'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept'
      //   }
      //   axios
      //     .get('https://newcrm.kundematch.dk/bitrix/components/hvdk/webapi/file.php?method=udbudjobsdata', {headers} ) .then(
      //       res => {
      //         console.log('res', res)
      //         if (res.success === true) {
      //           var results = res.data
      //           console.log('bitrix', results)
      //           // this.showAlert()
      //         }
      //       })
      // } catch (e) {
      // }
    },
    reloadudbudtest () {
      this.salesPerson = localStorage.getItem('id_token_portal')
      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      }
      var data = {
      }
      this.$http.get(this.$bitrixapi + 'bitrix/getValidTed', data, { headers }, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            var cities = []
            var categorywork = []
            this.itemMester = res.data.filter(function (a) {
              return a.ACTIVE_TENDER !== 'Yess'
            })
            // cities
            res.data.forEach(element => {
              cities.push(element.CITY)
            })
            const unique = (value, index, self) => {
              return self.indexOf(value) === index
            }
            this.citiesfilter = cities.filter(unique)

            // category
            res.data.forEach(element => {
              // console.log('element', element.CATEGORY)
              var catitem = element.CATEGORY !== null ? element.CATEGORY : 'Empty'
              var catitemclean = catitem.split(',')
              if (catitemclean.length > 1) {
                catitemclean.forEach(item => {
                  categorywork.push(item.trim())
                })
              } else {
                categorywork.push(catitem)
              }
            })
            const uniquecategory = (value, index, self) => {
              return self.indexOf(value) === index
            }
            this.categoryfilter = categorywork.filter(uniquecategory)
            if (this.search !== '') {
              this.updateSearch()
            } else {
              this.SearchItem = this.itemMester
            }
            // console.log('SearchItem', this.SearchItem)
          },
          response => {
            console.log('error in loading all udbud')
          }
        )
    },
    filterSearch (item) {
      return item
    },
    toggleFilter (status) {
      var items = []
      var filtered = []
      if (status.length !== 0) {
        for (var i = 0; i < status.length; i++) {
          items = this.itemMester.filter((item) => {
            return item.CATEGORY.trim().includes(status[i]) || item.CITY.includes(status[i])
          })
          items.forEach(function (value) {
            filtered.push(value)
          })
        }
        this.SearchItem = this.filterSearch(filtered)
      } else {
        this.SearchItem = this.filterSearch(this.itemMester)
      }
    },
    toggleSort (statusDate) {
      var items = []
      var order
      if (statusDate === '2') {
        order = this.oldestFirst ? 1 : -1
        items = this.itemMester.sort(function (a, b) {
          a = new Date(a.DATE_CREATED)
          b = new Date(b.DATE_CREATED)
          var results = a > b ? -1 : a < b ? 1 : 0
          return results * order
        })
        this.SearchItem = this.filterSearch(items)
        this.oldestFirst = !this.oldestFirst
      } else if (statusDate === '1') {
        order = this.ascending ? 1 : -1
        items = this.itemMester.sort(function (a, b) {
          a = a.CITY
          b = b.CITY
          var results = a > b ? -1 : a < b ? 1 : 0
          return results * order
        })
        this.SearchItem = this.filterSearch(items)
        this.ascending = !this.ascending
      } else if (statusDate === '3') {
        order = this.oldestFirst ? 1 : -1
        items = this.itemMester.sort(function (a, b) {
          a = new Date(a.DATE_EDITED)
          b = new Date(b.DATE_EDITED)
          var results = a > b ? -1 : a < b ? 1 : 0
          return results * order
        })
        this.SearchItem = this.filterSearch(items)
        this.oldestFirst = !this.oldestFirst
      } else if (statusDate === '4') {
        order = this.oldestFirst ? 1 : -1
        items = this.itemMester.sort(function (a, b) {
          a = new Date(a.TENDER_DEADLINE)
          b = new Date(b.TENDER_DEADLINE)
          var results = a > b ? -1 : a < b ? 1 : 0
          return results * order
        })
        this.SearchItem = this.filterSearch(items)
        this.oldestFirst = !this.oldestFirst
      }
    },
    updateSearch () {
      var items = []
      items = this.itemMester.filter((item) => {
        return item.TENDER_TITLE.toLowerCase().includes(this.search.toLowerCase()) || item.DATE_CREATED.toLowerCase().includes(this.search.toLowerCase()) || item.PROCUREMENT_TITLE.toLowerCase().includes(this.search.toLowerCase()) || item.CITY.toLowerCase().includes(this.search.toLowerCase()) || item.POSTAL_CODE.toLowerCase().includes(this.search.toLowerCase())
      })
      this.SearchItem = this.filterSearch(items)
    },
    formatCurrency (total) {
      var neg = false
      if (total < 0) {
        neg = true
        total = Math.abs(total)
      }
      return (neg ? '' : '') + parseFloat(total, 10).toFixed(0).replace('.', ',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.').toString()
    },
    hideModal () {
      this.itemShow = false
      this.$refs.itemModal.hide()
    }
  }
}
</script>
<style>
#udbudpage .dg-content{
  white-space:pre-wrap;
}
#udbudpage .custom-control-input {
      position: unset;
    z-index: 1;
    opacity: 1;
    margin-right: 14px;
}
#udbudpage .image {
    width: 200px;
    height: 200px;
    background-size: contain;
    cursor: pointer;
    margin: 10px;
    border-radius: 3px;
}
#udbudpage .field-input {
  border-radius: 0!important;
  background: rgba(230, 234, 235, 0.5)!important;
  border:0!important;
}

#udbudpage .greenblue-button {
    color: #fff;
    background-color: rgba(77, 207, 85, 1.0);
    border: 0;
}
#udbudpage .searchBox {
  border: 0;
  flex: 1;
  outline:none;
}
#udbudpage .dg-content{
  white-space:pre-wrap;
}
#udbudpage .container {
  padding:0;
}
#udbudpage .loader,
.loader:before,
.loader:after {
  border-radius: 50%;
}
#udbudpage .loader {
  color: #143130;
  font-size: 11px;
  text-indent: -99999em;
  margin: 55px auto;
  position: relative;
  width: 10em;
  height: 10em;
  box-shadow: inset 0 0 0 1em;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
}
#udbudpage .loader:before,
.loader:after {
  position: absolute;
  content: '';
}
#udbudpage .loader:before {
  width: 5.2em;
  height: 10.2em;
  background: white;
  border-radius: 10.2em 0 0 10.2em;
  top: -0.1em;
  left: -0.1em;
  -webkit-transform-origin: 5.2em 5.1em;
  transform-origin: 5.2em 5.1em;
  -webkit-animation: load2 2s infinite ease 1.5s;
  animation: load2 2s infinite ease 1.5s;
}
#udbudpage .loader:after {
  width: 5.2em;
  height: 10.2em;
  background: white;
  border-radius: 0 10.2em 10.2em 0;
  top: -0.1em;
  left: 5.1em;
  -webkit-transform-origin: 0px 5.1em;
  transform-origin: 0px 5.1em;
  -webkit-animation: load2 2s infinite ease;
  animation: load2 2s infinite ease;
}
@-webkit-keyframes load2 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes load2 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
#udbudpage .modal-footer,
.modal-header {
  padding: 0;
}
#udbudpage .modal-header,
.modal-footer {
  border-bottom: 0;
  border-top: 0;
}
#udbudpage .modal-backdrop.show {
  opacity: 0.8;
  background-color: rgba(44, 62, 80, 0.975);
}
#udbudpage .modal-body-marketplace {
  padding: 0!important;
}
#udbudpage .modal-footer > div {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// ted_udbud.vue?edc65384